import { Link } from 'react-router-dom';

interface ArticleCardProps {
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  image: string;
  slug: string;
  variant?: 'default' | 'accent';
  className?: string;
}

export default function ArticleCard({ title, category, categorySlug, date, image, slug, variant = 'default', className = '' }: ArticleCardProps) {
  if (variant === 'accent') {
    return (
      <Link to="/category/all" className={`group block cursor-pointer ${className}`}>
        <div className="rounded-2xl overflow-hidden bg-primary-800 h-full flex flex-col items-center justify-center p-8 text-center min-h-[320px]">
          <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-accent-500/20 mb-5">
            <i className="ri-fire-line text-3xl md:text-4xl text-accent-400"></i>
          </div>
          <span className="inline-block px-3 py-1 text-xs rounded-full bg-accent-500/20 text-accent-300 mb-3">
            {category}
          </span>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-background-50 leading-relaxed group-hover:text-accent-300 transition-colors">
            {title}
          </h3>
          <p className="mt-3 text-sm text-background-50/50">{date}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link to="/category/all" className={`group block cursor-pointer ${className}`}>
      <div className="rounded-2xl overflow-hidden bg-background-100 transition-all duration-300 hover:bg-background-200">
        <div className="aspect-[4/3] overflow-hidden">
          <img
            src={image}
            alt={title}
            title={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <div className="p-5">
          <span className="inline-block px-3 py-1 text-xs rounded-full bg-accent-100 text-accent-800 mb-3">
            {category}
          </span>
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 leading-relaxed group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h3>
          <p className="mt-2 text-xs text-foreground-500">{date}</p>
        </div>
      </div>
    </Link>
  );
}